





































































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";
import VueNumeric from "vue-numeric";
import { InputMask } from "@/shared/interfaces/InputMask.interface";
export default Vue.extend({

    components: {
        VueNumeric: VueNumeric
    },

    props: {
        errorMessage: {
            type: String,
            required: false,
            default: null
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false
        },
        name: {
            type: String,
            required: false,
            default: "price"
        },
        ariaLabelTooltip: {
            type: String,
            required: false,
            default: ""
        },
        input: {
            type: [String, Number],
            default: 0
        },
        inputTooltip: {
            type: Boolean,
            required: false,
            default: false
        },
        inputLabel: {
            type: String,
            required: false,
            default: ""
        },
        inputOptional: {
            type: Boolean,
            required: false,
            default: true
        },
        inputDescription: {
            type: String,
            required: false,
            default: ""
        },
        minValue: {
            type: Number,
            default: null
        },
        maxValue: {
            type: Number,
            default: null
        },
        valueType: {
            type: String,
            required: false,
            default: "price"
        },
        gridLayout: {
            type: String,
            required: false,
            default: ""
        },
        specificId: {
            type: String,
            required: false,
            default: ""
        },
    },

    data: function() {
        return {
            internalInput: this.input,
            groupFocused: false,
            uniqueId: (this.specificId != "") ? this.specificId : uuidv4() as string
        };
    },

    computed: {
        options: function(): InputMask {
            return this.getInputMask(this.valueType);
        },
        setMinValue: function(): number {
            let minValue = this.minValue;
            if(minValue === null) {
                minValue = this.options.min;
            }
            return minValue;
        },
        setMaxValue: function(): number {
            let maxValue = this.maxValue;
            if(maxValue === null) {
                maxValue = this.options.max;
            }
            return maxValue;
        },
        className: function(): string {
            let className = "input--text";
            if (this.errorMessage) {
                className += " input--error";
            }
            if(this.gridLayout !== "") {
                className += " " + this.gridLayout;
            }

            return className;
        }
    },

    watch: {
        inputTo: function() {
            this.internalInput = this.input;
        },
        internalInput: function() {
            this.$emit("update-value", this.internalInput);
        }
    },
    methods: {
        onFocus: function () {
            this.groupFocused = true;
        },
        onBlur: function () {
            this.groupFocused = false;
            this.$emit("blur");
        }
    }

});
